export default function utcDateToMidnightLocal(d: Date): Date | null {
  if (d == null) {
    return null
  }

  return new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate())
}
